module.exports = __webpack_public_path__ + "static/media/dynamodb182.b6d98851.png";